import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { formatDateWithYear } from '@/utils/dateFormatters';
import BreadcrumbComponent from '@/components/BreadcrumbComponent';
import { FileCheck, FileText } from 'lucide-react';
import CardSkeleton from '@/components/CardSkeleton';
import { useCertificates } from '@/hooks/useCertificates';
import CertificatesStub from '@/components/CertificatesStub';
import { Typography } from '@/components/ui/typography';

const Certificates = () => {
  const { certificates, isLoading } = useCertificates();

  return (
    <div className="flex flex-col p-3 w-full">
      <BreadcrumbComponent link={'Cправки'} />
      <div className="mb-6 flex items-center gap-2">
        <FileText className="h-5 w-5 text-primary" />
        <h2 className="text-xl font-medium text-gray-900">Справки</h2>
      </div>
      <div className="grid gap-4 m:grid-cols-1">
        {!isLoading && (!certificates || certificates.length === 0) && <CertificatesStub />}
        {isLoading
          ? [...Array(1)].map((_, index) => <CardSkeleton key={index} />)
          : certificates.map((certificate) => (
              <Card key={certificate.id} className="overflow-hidden transition-all hover:shadow-lg">
                <CardHeader className="border-b bg-gradient-to-r from-primary/5 to-primary/10 p-4">
                  <div className="flex flex-col gap-2">
                    <div className="group flex items-center gap-3">
                      <div className="rounded-full bg-primary/10 p-2 sm:p-2">
                        <FileCheck className="h-5 w-5 text-primary" />
                      </div>
                      <Typography
                        variant="h3"
                        className="min-w-[40rem] md:min-w-[20rem] font-normal text-lg text-gray-800 group-hover:text-primary transition-colors">
                        {certificate.name}
                      </Typography>
                    </div>
                  </div>
                </CardHeader>
                <CardContent className="space-y-4 p-4">
                  <div className="flex flex-col gap-3">
                    <div className="flex items-center justify-between text-sm">
                      <Typography variant="muted" className="block">
                        Справка действительна до:{' '}
                      </Typography>
                      <Typography variant="p" className="text-base leading-relaxed">
                        {formatDateWithYear(certificate.end_date)}
                      </Typography>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
      </div>
    </div>
  );
};

export default Certificates;
